import { get } from 'lodash';

class NewsPostController {
  /* @ngInject */
  constructor($rootScope, $state, $filter, $timeout, HelperService) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = vm.newsPost.title;
      $rootScope.pageDescription = $filter('plainText')(
        get(vm, 'newsPost.fields.body.html', '')
      );

      vm.artist = vm.newsPost.fields.artist[0];
      vm.assets = HelperService.group(vm.newsPost.fields.assets);

      vm.nextPost = vm.newsPost.next;

      vm.unmuteVideo = !$state.history[0];

      $timeout(() => {
        vm.shrinkHeader = true;
      }, 1500);
    };
  }
}

export default NewsPostController;
